export default __webpack_public_path__ + "static/media/M2HairSalon.73de7472.jpg";